import { render, staticRenderFns } from "./RecommRank.vue?vue&type=template&id=759936e8&scoped=true&lang=true&"
import script from "./RecommRank.vue?vue&type=script&lang=js&"
export * from "./RecommRank.vue?vue&type=script&lang=js&"
import style0 from "./RecommRank.vue?vue&type=style&index=0&id=759936e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759936e8",
  null
  
)

export default component.exports